import React, { useState, useEffect, useContext } from 'react';
import { Table, Button, InputNumber, Modal, Typography, message } from 'antd';
import axios from 'axios';
import { LoginContext } from '../../context/loginContext';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

const ArticulosTable = ({ posicion }) => {
    const [articulos, setArticulos] = useState([]);
    const [selectedArticulos, setSelectedArticulos] = useState([]);
    const { user } = useContext(LoginContext);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchArticulos();
    }, []);

    useEffect(() => {
        if (articulos.length > 0) {
            setIsModalVisible(true); // Opens modal if articles are available
        }
    }, [articulos]);

    const fetchArticulos = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/articulos`, {
                headers: { Authorization: `Bearer ${user.token}` },
            });
            setArticulos(response.data);
        } catch (error) {
            message.error('Error al obtener artículos');
        }
    };

    const handleCantidadChange = (value, articuloId) => {
        const updatedArticulos = selectedArticulos.map(art =>
            art._id === articuloId ? { ...art, cantidad: value } : art
        );
        setSelectedArticulos(updatedArticulos);
    };

    const handleArticuloSelection = (selectedRowKeys, selectedRows) => {
        const updatedSelectedArticulos = [...selectedArticulos];

        selectedRows.forEach(articulo => {
            const existingIndex = updatedSelectedArticulos.findIndex(selected => selected._id === articulo._id);
            if (existingIndex > -1) {
                // Si el artículo ya está seleccionado, actualiza su cantidad
                updatedSelectedArticulos[existingIndex].cantidad = 1; // Cambia a la cantidad deseada
            } else {
                // Si el artículo no está en la selección, agrégalo
                updatedSelectedArticulos.push({ ...articulo, cantidad: 1 });
            }
        });

        setSelectedArticulos(updatedSelectedArticulos);
    };

    const handleOk = async () => {
        try {
            const dataToSend = {
                articulos: selectedArticulos.map(art => ({
                    articulo: art._id,
                    cantidad: art.cantidad,
                })),
            };
    
            console.log('Artículos seleccionados:', dataToSend.articulos);
            console.log('POSICION', posicion);
    
            await axios.put(`${process.env.REACT_APP_API_URL}/movimientos/${posicion}/agregar-articulos`, dataToSend, {
                headers: { Authorization: `Bearer ${user.token}` },
            });
    
            message.success('Artículos agregados al movimiento con éxito');
            setIsModalVisible(false); // Cierra el modal después de guardar
            setSelectedArticulos([]); // Limpia la selección de artículos si es necesario
            navigate('/posiciones');
        } catch (error) {
            console.error('Error al agregar artículos:', error);
            message.error('Error al agregar artículos al movimiento');
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false); // Closes modal
    };

    const articuloColumns = [
        { title: 'Artículo', dataIndex: 'nombre', key: 'nombre' },
        {
            title: 'Marca',
            dataIndex: 'idmarca',
            key: 'idmarca',
            render: (idmarca) => (idmarca ? idmarca.nombre : 'N/A'),
        },
        {
            title: 'Categoría',
            dataIndex: 'idcategoria',
            key: 'idcategoria',
            render: (idcategoria) => (idcategoria ? idcategoria.nombre : 'N/A'),
        },
        { title: 'Unidad de Medida', dataIndex: 'unidadDeMedida', key: 'unidadDeMedida' },
    ];

    const selectedArticulosColumns = [
        ...articuloColumns,
        {
            title: 'Cantidad',
            dataIndex: 'cantidad',
            key: 'cantidad',
            render: (text, record) => (
                <InputNumber
                    min={1}
                    value={record.cantidad}
                    onChange={(value) => handleCantidadChange(value, record._id)}
                />
            ),
        },
    ];

    return (
        <Modal
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            title="Lista de Artículos"
            centered
            width={800}
        >
            <Title level={4}>Seleccione los artículos</Title>
            <Table
                rowSelection={{
                    onChange: handleArticuloSelection,
                }}
                columns={articuloColumns}
                dataSource={articulos}
                pagination={{ pageSize: 5 }}
                rowKey="_id"
                style={{ marginBottom: 20 }}
            />
            {selectedArticulos.length > 0 && (
                <>
                    <Title level={4}>Artículos Seleccionados</Title>
                    <Table
                        dataSource={selectedArticulos}
                        columns={selectedArticulosColumns}
                        rowKey="_id"
                        pagination={false}
                    />
                </>
            )}
        </Modal>
    );
};

export default ArticulosTable;
